import { __makeTemplateObject } from './../../external/tslib/tslib.es6.js';
import styled, { css } from 'styled-components';
import { defaultValueVariation } from './Badge.js';

var StyledBadge = styled.span(function (_a) {
    var badge = _a.theme.olist.components.badge, _b = _a.variation, variation = _b === void 0 ? defaultValueVariation : _b, pill = _a.pill;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n\n    background: ", ";\n    color: ", ";\n\n    border-radius: ", ";\n  "], ["\n    padding: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n\n    background: ", ";\n    color: ", ";\n\n    border-radius: ", ";\n  "])), badge.padding, badge['font-size'], badge['line-height'], badge['font-weight'], badge.variation[variation].background, badge.variation[variation].color, pill ? badge.radius.pill : badge.radius.default);
});
var templateObject_1;

export { StyledBadge };
